import Reveal from '@/components/base/Reveal';

const statusRows = [
  { label: 'MARKET', value: 'XAUUSD', tone: 'default' as const },
  { label: 'FILTER', value: 'REJECTED', tone: 'default' as const },
  { label: 'ACTION', value: 'NO TRADE', tone: 'gold' as const },
];

function StepWaiting() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <p className="text-[11px] font-data tracking-[0.24em] text-primary-600 mb-5">
            WHEN THE FILTER REJECTS
          </p>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[32px] leading-[1.08] sm:text-[42px] lg:text-[46px]">
            No Setup. No Trade.
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-foreground-600 max-w-[520px]">
            When the filter returns a reject, the EA does not override it. Nothing is sent to MT5.
            The engine simply drops back to ingestion and keeps reading XAUUSD, ready to filter the
            next setup.
          </p>
          <p className="mt-6 text-[12px] font-data tracking-[0.16em] text-foreground-400">
            A REJECT IS NOT AN ERROR — IT IS THE RULE WORKING.
          </p>
        </Reveal>

        <Reveal delay={140}>
          <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
            <div className="flex items-center justify-between px-5 h-12 border-b border-background-200 bg-background-100">
              <span className="text-[12px] font-data tracking-widest text-foreground-700">
                ENGINE STATUS
              </span>
              <span className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-profit-500"></span>
                <span className="text-[10px] font-data tracking-widest text-profit-600">ACTIVE</span>
              </span>
            </div>
            <div className="divide-y divide-background-200">
              {statusRows.map((row) => (
                <div key={row.label} className="flex items-center justify-between px-5 py-4">
                  <span className="text-[12px] font-data tracking-widest text-foreground-500">
                    {row.label}
                  </span>
                  <span className="flex items-center gap-2">
                    {row.tone === 'gold' && (
                      <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
                    )}
                    <span
                      className={`text-[14px] font-data font-semibold tracking-wider ${
                        row.tone === 'gold' ? 'text-primary-600' : 'text-foreground-950'
                      }`}
                    >
                      {row.value}
                    </span>
                  </span>
                </div>
              ))}
            </div>
            <div className="px-5 py-3.5 border-t border-background-200 bg-background-100">
              <p className="text-[10px] font-data tracking-widest text-foreground-400">
                STILL INGESTING · STILL FILTERING XAUUSD
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default StepWaiting;